import { Trans } from 'react-i18next';

import { ArrowBackIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import { Box, Button, ButtonProps, useColorModeValue } from '@chakra-ui/react';

interface BackButtonProps extends ButtonProps {
  btnText: string;
  onClick: () => void;
  isArabic: boolean;
}

const BackButton = ({ onClick, btnText, isArabic }: BackButtonProps) => {
  return (
    <Button
      variant="unstyled"
      display="flex"
      alignItems="center"
      onClick={onClick}
      w="fit-content"
      h="fit-content"
      fontSize={{ base: 'xs', md: 'sm' }}
      gap="3"
      fontWeight="medium"
      pos="fixed"
      left={{
        base: isArabic ? 'unset' : '1rem',
        md: isArabic ? 'unset' : '5vh',
      }}
      right={{
        base: isArabic ? '1rem' : 'unset',
        md: isArabic ? '5vh' : 'unset',
      }}
      top={{ base: '9.5vh', md: '14.3vh' }}
      color="#353535"
      zIndex={1}
    >
      <ArrowBackIcon
        boxSize="2rem"
        border="1px solid #D1DADF"
        borderRadius="lg"
        w={{ base: '25px', md: '32px' }}
        h={{ base: '25px', md: '32px' }}
        p="1"
        color="#353535"
        transform={`rotate(${isArabic ? 180 : 0}deg)`}
      />
      {btnText}
    </Button>
  );
};

export default BackButton;
